export const NAV_LINKS = [
  { label: "Home", href: "#top" },
  { label: "Care", href: "#services" },
  { label: "Physician", href: "#doctors" },
  { label: "Financing", href: "#financing" },
  { label: "Journal", href: "#resources" },
  { label: "FAQ", href: "#faq" },
  { label: "Visit", href: "#contact" },
];

export const FAQ_GROUPS = [
  {
    category: "Getting Started",
    items: [
      {
        q: "What is ASTERA Women's Health?",
        a: [
          "ASTERA is a physician-led women's health clinic focused on perimenopause, menopause, hormone therapy, intimate and vulvar health, sexual wellness, and physician-performed surgical procedures including labiaplasty and corrective vulvar procedures.",
        ],
      },
      {
        q: "Do I need a referral?",
        a: ["No. You can contact ASTERA directly to book an appointment."],
      },
      {
        q: "How do I get started?",
        a: [
          "For hormonal, menopause or general women's health concerns, care begins with a Comprehensive Women's Health Assessment for $350, which includes two appointments with Dr. Fefelova.",
          "If you are interested specifically in labiaplasty or another corrective vulvar procedure, you can book a surgical consultation to discuss your concerns and available options.",
        ],
      },
      {
        q: "What does the $350 assessment include?",
        a: [
          "Your first visit focuses on your symptoms, medical history, concerns and goals. Dr. Fefelova may order bloodwork, ultrasound or other investigations where appropriate.",
          "Your second visit is included in the $350 fee and focuses on reviewing your results, discussing treatment options and creating your personalized care plan.",
        ],
      },
      {
        q: "Do I need bloodwork before my first appointment?",
        a: [
          "No. If testing is needed, Dr. Fefelova will determine what is appropriate after your initial assessment. You are welcome to bring any recent relevant results with you.",
        ],
      },
      {
        q: "Are bloodwork and ultrasound included in the $350?",
        a: [
          "No. The $350 covers your two ASTERA physician appointments. Laboratory, imaging or other outside diagnostic services are separate.",
        ],
      },
      {
        q: "What happens after my second appointment?",
        a: [
          "Your next steps depend on your individual needs and may include treatment, prescriptions, monitoring, additional investigation or follow-up care.",
        ],
      },
      {
        q: "Do you offer financing or payment options?",
        a: [
          "Yes. We partner with trusted financing providers — PayBright, Credit Medical and Medicard — so you can begin your care now and pay over time. You can apply online or by phone; see our Financing section for details.",
        ],
      },
      {
        q: "Where is ASTERA located and how do I reach you?",
        a: [
          "ASTERA is located at 7982 Yonge St, Innisfil, ON L9S 1L5.",
          "You can text or call us at (249) 388-2997 or (705) 985-7295, or email hello@asterawomenshealth.ca. You're also welcome to send a request through the booking form on this page.",
        ],
      },
    ],
  },
  {
    category: "Perimenopause, Menopause & Hormones",
    items: [
      {
        q: "What symptoms can perimenopause and menopause cause?",
        a: [
          "Perimenopause and menopause can bring hot flashes, night sweats, disrupted sleep, changes in mood and energy, brain fog and shifts in libido, among others. Symptoms vary widely from woman to woman.",
          "Care at ASTERA begins by mapping your symptoms and understanding how they affect your daily life.",
        ],
      },
      {
        q: "What is hormone therapy, and do you offer bioidentical hormones (BHRT)?",
        a: [
          "Yes. We offer personalized hormone therapy, including Bioidentical Hormone Replacement Therapy (BHRT), designed to restore balance and improve quality of life.",
          "Your plan is tailored to your symptoms, history and goals, and is carefully monitored over time.",
        ],
      },
      {
        q: "Is hormone therapy right for me?",
        a: [
          "Hormone therapy isn't one-size-fits-all. Dr. Fefelova reviews your full picture — symptoms, medical history, investigations and your own preferences — and discusses the potential benefits and risks before recommending an individualized approach.",
        ],
      },
      {
        q: "How do I begin hormonal or menopause care?",
        a: [
          "Care begins with a Comprehensive Women's Health Assessment for $350, which includes two appointments with Dr. Fefelova — the first to understand your concerns, the second to review results and create your personalized plan.",
        ],
      },
    ],
  },
  {
    category: "Intimate & Vulvar Health",
    items: [
      {
        q: "What does intimate and vulvar health care cover?",
        a: [
          "Confidential care for concerns affecting comfort, confidence and sexual wellness — including vaginal dryness, discomfort, vulvar conditions and sexual wellness consultations.",
        ],
      },
      {
        q: "What is PRP (Platelet-Rich Plasma) therapy?",
        a: [
          "PRP therapy uses a small sample of your own blood, processed to concentrate its platelets, which is then used to support tissue health and intimate wellness.",
          "Whether PRP is appropriate for you is determined during a consultation with Dr. Fefelova, based on your symptoms, concerns and goals.",
        ],
      },
      {
        q: "Can you help with vaginal dryness or discomfort?",
        a: [
          "Yes. These are common, treatable concerns — often related to hormonal changes. Dr. Fefelova will assess the cause and discuss the options best suited to you.",
        ],
      },
      {
        q: "I feel uncomfortable discussing sexual health. How do you handle these conversations?",
        a: [
          "With warmth, candor and zero judgment. Sexual health is health, and these conversations are held in a private, respectful setting — no concern is too small or too personal.",
        ],
      },
    ],
  },
  {
    category: "Labiaplasty & Corrective Vulvar Procedures",
    items: [
      {
        q: "What surgical procedures does ASTERA offer?",
        a: [
          "ASTERA provides labiaplasty and corrective vulvar procedures performed by Dr. Fefelova.",
          "These procedures may address physical discomfort, irritation, asymmetry, changes following childbirth or previous procedures, as well as personal aesthetic concerns. A surgical consultation is required to determine the most appropriate treatment.",
        ],
      },
      {
        q: "What is labiaplasty?",
        a: [
          "Labiaplasty is a surgical procedure that reshapes or reduces the labia. The procedure is customized to your individual anatomy, concerns and desired outcome.",
        ],
      },
      {
        q: "Why do women choose labiaplasty?",
        a: [
          "Women may seek labiaplasty because of discomfort with exercise, clothing or intimacy, persistent irritation, asymmetry, changes following childbirth, previous procedures or concerns about appearance.",
        ],
      },
      {
        q: "Is labiaplasty only cosmetic?",
        a: [
          "No. For some women, labiaplasty addresses functional concerns such as discomfort, irritation or anatomical changes. For others, aesthetic concerns may also be important. Often, it is a combination of both.",
        ],
      },
      {
        q: "What are corrective vulvar procedures?",
        a: [
          "Corrective vulvar procedures are individualized surgical treatments used to address concerns involving vulvar anatomy, symmetry, comfort or changes following childbirth or previous procedures.",
          "Dr. Fefelova will assess your individual concern and explain whether a corrective procedure may be appropriate.",
        ],
      },
      {
        q: "Do you offer PRP (Platelet-Rich Plasma) therapy?",
        a: [
          "Yes. PRP uses a small sample of your own blood, processed to concentrate its platelets, to support tissue health and healing.",
          "Depending on your concern, PRP may be considered on its own or alongside a corrective procedure. Dr. Fefelova will advise whether it's appropriate for you during your consultation.",
        ],
      },
      {
        q: "What happens during a surgical consultation?",
        a: [
          "Dr. Fefelova will discuss your concerns, goals and medical history and assess the area if appropriate. She will explain your surgical options, expected outcome, risks, recovery and aftercare before you decide whether to proceed.",
        ],
      },
      {
        q: "What is recovery like?",
        a: [
          "Recovery depends on the procedure performed and individual healing. You will receive specific instructions regarding work, physical activity, exercise, intimacy and aftercare.",
        ],
      },
      {
        q: "Will there be scarring or changes in sensation?",
        a: [
          "All surgery carries potential risks, including scarring and changes in sensation. Your individual risks and realistic expected outcome will be discussed thoroughly during your consultation.",
        ],
      },
    ],
  },
];

export const FINANCING = [
  {
    name: "PayBright",
    tagline: "Flexible monthly payments, in minutes.",
    points: [
      "Affordable monthly / semi-monthly payments",
      "Renewable credit limit",
      "Accelerated payment options",
      "Open-ended loan — pay off any time",
      "Application takes less than a minute",
      "Instant result display",
      "Applying will not affect your credit score",
    ],
    phoneLabel: "(877) 276-2780",
    phone: "+18772762780",
    apply: "https://www.affirm.com/en-ca",
  },
  {
    name: "Credit Medical",
    tagline: "Fast, confidential approval with fixed rates.",
    points: [
      "Fast and easy credit approval",
      "No down payment or collateral required",
      "Assured confidentiality",
      "Competitive, fixed interest rate for the term",
      "Open loans — pay out at any time",
      "Borrow any amount you need ($1,000 minimum)",
      "Flexible terms (6 months to 5 years)",
    ],
    phoneLabel: "1 (800) 270-9290",
    phone: "+18002709290",
    apply: "https://creditmedical.com/",
  },
  {
    name: "Medicard | Finance",
    tagline: "Same-day approval, up to $18,000.",
    points: [
      "Online and phone application",
      "Same-day approval",
      "Payment terms up to 6 years",
      "Rates based on loan size (7.9% – 15.9%)",
      "No down payment required",
      "Loans up to $18,000",
      "No penalties for early payments",
    ],
    phoneLabel: "(888) 689-9876",
    phone: "+18886899876",
    apply: "https://apply.medicard.com/",
  },
];

export const IMAGES = {
  hero: "/hero.jpg",
  about: "https://images.unsplash.com/photo-1767439565605-628d6e875b7b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  clinic: "https://images.unsplash.com/photo-1772751541531-e084e8f56630?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "Midlife is not a decline. It is a threshold.",
    body: "Perimenopause and menopause reshape the body in ways medicine has too often ignored. At ASTERA, this season is met with curiosity, evidence and warmth — never dismissal.",
  },
  {
    n: "02",
    title: "Hormones deserve nuance, not one-size answers.",
    body: "We read the full picture — labs, symptoms, history and your own goals — before shaping a hormone strategy that is genuinely yours, and revisited as you change.",
  },
  {
    n: "03",
    title: "Sexual health is health. Full stop.",
    body: "Desire, comfort and intimacy are essential to wellbeing. We hold space for these conversations with candor and zero shame, and we treat what others leave unspoken.",
  },
];

export const SERVICES = [
  {
    icon: "Flower2",
    title: "Perimenopause / Menopause Care",
    desc: "Personalized, physician-led care to manage the physical and emotional changes of perimenopause and menopause.",
    points: [
      "Bioidentical Hormone Replacement Therapy (BHRT)",
      "Comprehensive hormone assessments",
      "Individualized symptom management plans",
      "Hot flashes, night sweats & sleep concerns",
      "Mood, energy & healthy aging support",
    ],
  },
  {
    icon: "HeartHandshake",
    title: "Intimate & Vulvar Health",
    desc: "Confidential care for conditions affecting comfort, confidence, and sexual wellness.",
    points: [
      "PRP (Platelet-Rich Plasma) therapy",
      "Vaginal dryness, discomfort & vulvar conditions",
      "Sexual wellness consultations",
    ],
  },
  {
    icon: "Stethoscope",
    title: "Labiaplasty & Corrective Procedures",
    desc: "Expert surgical care tailored to your functional and aesthetic goals.",
    points: [
      "Labiaplasty",
      "Corrective vulvar procedures",
      "Personalized surgical consultations",
    ],
  },
];

export const DOCTOR = {
  name: "Dr. Evgeniya Fefelova",
  role: "Double Board-Certified Obstetrician-Gynaecologist",
  creds: "MD · Ph.D. in Medicine · FRCSC",
  img: "/dr-fefelova.jpg",
  badges: [
    "Double Board-Certified",
    "MD, Ph.D. in Medicine",
    "FRCSC",
    "20+ Years' Experience",
  ],
  bio: [
    "Dr. Fefelova is a double board-certified obstetrician and gynaecologist who has devoted her career to helping women optimize their health. She joined Royal Victoria Hospital in 2014 and established her full-time OB/GYN practice in Barrie, Ontario that same year.",
    "With 20 years of experience, she brings specialized knowledge, skill and professional capability across both the medical and surgical care of the female reproductive system — with particular expertise in menopause and mature women's health.",
    "Throughout her career she has built her knowledge and skills with social accountability, so she can serve a diversity of patients with consistently high-quality care.",
  ],
  expertise: [
    "Menopause & mature women's health",
    "Hormone & surgical gynaecologic care",
    "Paediatric gynaecology & infertility",
    "Advanced obstetrics",
  ],
  affiliation:
    "Affiliated with the Royal Victoria Health Centre and the Royal Centre of Plastic Surgery — Barrie, Ontario.",
};

export const TESTIMONIALS = [
  {
    quote: "For the first time a doctor listened to all of it — the sleep, the moods, the fog — and gave me a plan. I feel like myself again.",
    name: "Diane R.",
    detail: "Patient, age 52",
    img: "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    quote: "ASTERA treated my sexual health like it mattered, without a hint of judgment. It changed my marriage and my confidence.",
    name: "Sofia L.",
    detail: "Patient, age 48",
    img: "https://images.unsplash.com/photo-1581714161666-dade083654ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    quote: "The hormone plan was tailored down to the detail and adjusted as I changed. Warm, brilliant, unhurried care.",
    name: "Grace M.",
    detail: "Patient, age 55",
    img: "https://images.unsplash.com/photo-1578079346242-110da34c1043?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
];

export const POSTS = [
  {
    slug: "perimenopause-timeline",
    tag: "Menopause",
    title: "The perimenopause timeline no one explained to you",
    read: "6 min read",
    excerpt:
      "Perimenopause can begin years before your last period. Here's what actually happens, and when.",
    img: "https://images.unsplash.com/photo-1621784460088-7d5175af93ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    body: [
      { type: "p", text: "Most women are told about menopause as a single moment — the day periods stop. In reality, the transition often begins in your early-to-mid forties and can unfold over a decade. That long, in-between stretch is perimenopause, and understanding it is the first step to feeling in control again." },
      { type: "h", text: "Stage one: the subtle shift" },
      { type: "p", text: "Cycles may still feel regular, but hormone levels start to fluctuate. You might notice changes in sleep, mood, or energy long before any change in your period. Because these symptoms are vague and easy to attribute to stress, they're frequently dismissed — including by clinicians." },
      { type: "h", text: "Stage two: the visible changes" },
      { type: "p", text: "Cycles become irregular, hot flashes and night sweats may appear, and many women describe brain fog or a shorter fuse. This is the stage where a proper hormone assessment and an individualised plan make the biggest difference to quality of life." },
      { type: "h", text: "Stage three: menopause and beyond" },
      { type: "p", text: "Menopause is confirmed twelve months after your final period. The years that follow — postmenopause — bring their own priorities around bone, heart and metabolic health, all of which deserve proactive, physician-led care." },
      { type: "p", text: "Wherever you are on this timeline, you don't have to guess your way through it. A thorough assessment can map exactly where you are and what will help." },
    ],
  },
  {
    slug: "hrt-2026-evidence",
    tag: "Hormones",
    title: "HRT in 2026: what the evidence actually says",
    read: "8 min read",
    excerpt:
      "Hormone therapy has been misunderstood for two decades. Here's a clear, current picture.",
    img: "/hormone.jpg",
    body: [
      { type: "p", text: "Few areas of women's health have been as clouded by outdated headlines as hormone replacement therapy. Much of the fear traces back to early readings of a single large study — readings that later research has significantly refined." },
      { type: "h", text: "What we understand today" },
      { type: "p", text: "For many women, particularly those who begin therapy within ten years of menopause, the benefits of HRT for symptom relief and long-term health can outweigh the risks. The key word is individualised: type of hormone, dose, and route all matter, and they should be chosen for you specifically." },
      { type: "h", text: "It is not one-size-fits-all" },
      { type: "p", text: "Your history, your symptoms and your goals shape the plan. That's why HRT should be prescribed and monitored by a physician who can weigh the full picture and adjust as your needs change over time." },
      { type: "h", text: "Ongoing monitoring matters" },
      { type: "p", text: "Starting therapy is the beginning, not the end. Regular follow-up ensures your plan continues to serve you — refining doses, checking in on symptoms, and keeping your care aligned with the latest evidence." },
      { type: "p", text: "If you've been putting off the conversation because of something you read years ago, it may be time for an up-to-date one." },
    ],
  },
  {
    slug: "desire-comfort-intimacy-midlife",
    tag: "Sexual Health",
    title: "Desire, comfort and intimacy through midlife",
    read: "5 min read",
    excerpt:
      "Changes to intimacy in midlife are common, treatable, and absolutely worth discussing.",
    img: "https://images.unsplash.com/photo-1609793081484-59f850bc1fbd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    body: [
      { type: "p", text: "Sexual health is health — yet it remains one of the most under-discussed aspects of midlife care. Shifts in desire, comfort and confidence are extremely common as hormones change, and they are rarely something you simply have to accept." },
      { type: "h", text: "Why it happens" },
      { type: "p", text: "Declining estrogen can lead to vaginal dryness, discomfort and changes in sensation, collectively affecting comfort and intimacy. These are physiological changes, not personal failings — and they respond well to care." },
      { type: "h", text: "What can help" },
      { type: "p", text: "Options range from targeted therapies for comfort and tissue health to treatments such as PRP, alongside honest, judgment-free consultations that address the whole picture. The right approach depends on you." },
      { type: "h", text: "The conversation you deserve" },
      { type: "p", text: "The most important step is simply being heard. In a physician-led, confidential setting, these concerns are met with candor and expertise — never embarrassment." },
      { type: "p", text: "If intimacy has changed and you'd like it to feel different, that's reason enough to start a conversation." },
    ],
  },
];

export const RIBBON = [
  "Perimenopause",
  "Menopause",
  "Hormone Therapy",
  "Intimate & Vulvar Health",
  "Sexual Wellness",
  "Preventive Care",
  "Healthy Aging",
];
